import React from "react";
import PropTypes from "prop-types";
import { Button } from "rsuite";
import NewsIcon from "../../../../assets/img/action-center/news.svg";
import ChevronRightSmIcon from "../../../../assets/img/action-center/chevron-right-sm.svg";
import useHeapCardViewed from "../../../../hooks/useHeapCardViewed";
import "./BlogCard.scss";

const BLOG_URL = "https://www.hoteltrader.com/resource-type/blog/";

const BlogCard = ({ cardPosition, hotelName }) => {
  const cardRef = useHeapCardViewed("blog", cardPosition, hotelName);
  const handleReadMore = () => {
    window.open(BLOG_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div ref={cardRef} className="blog-card">
      <div className="blog-card-badge">
        <img src={NewsIcon} alt="" className="badge-icon" />
      </div>

      <h3 className="blog-card-title">Latest from Our Blog</h3>

      <p className="blog-card-description">
        Stay ahead with our newest blog posts on travel trends and revenue
        optimisation strategies.
      </p>

      <div className="blog-card-actions">
        <Button
          id="action-blog-read"
          appearance="ghost"
          className="read-more-btn"
          onClick={handleReadMore}
        >
          Browse Articles{" "}
          <img src={ChevronRightSmIcon} alt="" className="btn-chevron" />
        </Button>
      </div>
    </div>
  );
};

BlogCard.propTypes = {
  cardPosition: PropTypes.number,
  hotelName: PropTypes.string,
};

export default BlogCard;
